export const getProductLink = (product) => {
  if (!product) {
    return "/";
  }

  if (product.link) {
    return product.link;
  }

  const id = String(product.id ?? "").trim();
  if (!id) {
    return "/";
  }

  const type = String(product.type ?? "").toLowerCase();

  if (type === "motor") {
    return `/products/engine-oils-for-motorbikes-and-outboards/motor-oil/motor/${id}`;
  }

  if (type === "synthetic") {
    return `/products/engine-oils-for-cars-and-transporters/engine-oil/synthetic/${id}`;
  }
  if(type==="service"){
    return `/products/operating-service-fluids/service-fluids/service/service/${id}`;
  }
   if(type==="transmission-fluid"){
    return `/products/gear-oils-transmission-fluids/gear-oils/transmission-fluid/${id}`
  }

  if(type==="gear"){
    return `/products/gear-oils-transmission-fluids/gear-oils/gear-oil/${id}`
  }


  return `/search?q=${encodeURIComponent(id)}`;
};
